import React from "react";
import {
  Typography,
  Box,
  Grid2,
} from "@mui/material";
import SettingsCard from "./SettingsCard";
import "./SettingsCard.css";

const Settings = () => {
  return (
    <Box className="settings-container">
      <Typography variant="h2" className="settings-title">
        Settings
      </Typography>
      <Grid2 container className="settings-grid">
        <SettingsCard
          title="Lessons"
          icon="MenuBook"
          subtitle="Manage your lessons"
          link="/settings/lessons"
        />
        <SettingsCard
          title="Users"
          icon="People"
          subtitle="Manage users"
          link="/settings/users"
        />
        <SettingsCard
          title="Gestión de Lecciones de Usuarios"
          icon="Assignment"
          subtitle="Visualiza el progreso de todos los usuarios en las lecciones"
          link="/settings/userlessons"
        />
        {/* Add more cards as needed */}
      </Grid2>
    </Box>
  );
};

export default Settings;